import { useNavigate } from "react-router-dom";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import useAuth from "../../../../hook/useAuth";
import { useState } from "react";
import axios from "axios";
import { baseURL } from "../../../../config/api";
import { validateMin } from "../../../../utils/validateMin";


export const AddTireFitment = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [height, setHeight] = useState<number>(0);
    const [sectionWidth, setSectionWidth] = useState<number>(0);
    const [metricWidth, setMetricWidth] = useState<number>(0);
    const [aspectRatio, setAspectRatio] = useState<number>(0);
    const [diameter, setDiameter] = useState<number>(0);
    const [isCommercial, setIsCommercial] = useState<string>("Yes");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        await axios
            .post(
                `${baseURL}tireFitments?userId=${auth?.id}`,
                JSON.stringify({
                    height,
                    sectionWidth,
                    metricWidth,
                    aspectRatio,
                    diameter,
                    isCommercial: isCommercial === "Yes" ? true : false,
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }


    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add Tire Fitment</h2>

                    <div className="mt-2 p-2">

                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Height</label>
                                            <input
                                                type="number"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={height}
                                                placeholder="Height"
                                                onChange={(e) => setHeight(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Metric Width</label>
                                            <input
                                                type="number"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={metricWidth}
                                                placeholder="Metric Width"
                                                onChange={(e) => setMetricWidth(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Diameter</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={diameter}
                                                placeholder="Diameter"
                                                onChange={(e) => setDiameter(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Second Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Section Width</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={sectionWidth}
                                                placeholder="Section Width"
                                                onChange={(e) => setSectionWidth(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>


                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Aspect Ratio</label>
                                            <input
                                                type="number"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={aspectRatio}
                                                placeholder="Aspect Ratio"
                                                onChange={(e) => setAspectRatio(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Commercial</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={isCommercial}
                                                onChange={(e) => setIsCommercial(e.target.value)}
                                            >
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}